document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const form = select.closest('form');
  const purchase = form.closest('.product-purchase');
  const addButton = form.querySelector('[name="add"]');
  addButton.disabled = option.dataset.available !== 'true';
  addButton.textContent = addButton.disabled ? addButton.dataset.sold : addButton.dataset.add;
  const price = purchase.querySelector('[data-price]');
  price.replaceChildren(document.createTextNode(option.dataset.price));
  if (option.dataset.compare) { const old = document.createElement('s'); old.textContent = option.dataset.compare; price.append(' ', old); }
  const quantity = form.querySelector('[name="quantity"]');
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
  quantity.value = quantity.min;
  const url = new URL(window.location.href); url.searchParams.set('variant',option.value); window.history.replaceState({},'',url);
  const media = document.getElementById('media-' + option.dataset.media);
  if (media) { for (const item of media.parentElement.children) item.classList.remove('is-selected'); media.classList.add('is-selected'); }
});
document.addEventListener('click', event => {
  for (const menu of document.querySelectorAll('.nav-dropdown[open], .mobile-nav[open]')) if (!menu.contains(event.target)) menu.removeAttribute('open');
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.nav-dropdown[open], .mobile-nav[open]')) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
});
